import {
    CREATE_KNITTING_INWARD_DETAILS_FAILURE,
    CREATE_KNITTING_INWARD_DETAILS_REQUEST,
    CREATE_KNITTING_INWARD_DETAILS_SUCCESS,
    CREATE_USER_FORM_KNITTING_INWARD_DETAILS,
    DELETE_KNITTING_INWARD_DETAILS_FAILURE,
    DELETE_KNITTING_INWARD_DETAILS_REQUEST,
    DELETE_KNITTING_INWARD_DETAILS_SUCCESS,
    FETCH_SINGLE_KNITTING_INWARD_DETAILS_FAILURE,
    FETCH_SINGLE_KNITTING_INWARD_DETAILS_REQUEST,
    FETCH_SINGLE_KNITTING_INWARD_DETAILS_SUCCESS,
    FETCH_KNITTING_INWARD_DETAILS_FAILURE,
    FETCH_KNITTING_INWARD_DETAILS_REQUEST,
    FETCH_KNITTING_INWARD_DETAILS_SUCCESS,
    KNITTING_INWARD_DETAILS_USERFORM_RESET,
    UPDATE_KNITTING_INWARD_DETAILS_FAILURE,
    UPDATE_KNITTING_INWARD_DETAILS_REQUEST,
    UPDATE_KNITTING_INWARD_DETAILS_SUCCESS,
    FETCH_KNITTING_INWARD_DETAILS_BY_ID_REQUEST,
    FETCH_KNITTING_INWARD_DETAILS_BY_ID_SUCCESS,
    FETCH_PREVIOUS_KNITTING_INWARD_DETAILS_REQUEST,
    FETCH_PREVIOUS_KNITTING_INWARD_DETAILS_SUCCESS,
    FETCH_PREVIOUS_KNITTING_INWARD_DETAILS_FAILURE,
    FETCH_KNITTING_INWARD_DETAILS_SO_AND_SN_REQUEST,
    FETCH_KNITTING_INWARD_DETAILS_SO_AND_SN_SUCCESS,
    FETCH_KNITTING_INWARD_DETAILS_SO_AND_SN_FAILURE,
    KNITTING_INWARD_DETAILS_PO_DETAILS_DISABLED
} from './knittingInwardDetails.actionsType';

export const KNITTING_INWARD_DETAILS = 'knittingInwardDetails';

let initialState = {
    loading: false,
    knittingInwardDetailsById: [],
    knittingInwardDetails: [],
    previousGetList: [],
    SOAndSNGetList: [],
    knittingInwardDetailsForm: {
        fldItemRate: 0,
        fldQuantity: 0,
        fldReceivingRolls: 0,
        fldGrossValue: 0,
        fldDiscountValue: 0,
        fldIGSTValue: 0,
        fldSGSTValue: 0,
        fldCGSTValue: 0,
        fldCGSTPercentage: 0,
        fldIGSTPercentage: 0,
        fldSGSTPercentage: 0,
        fldDiscountPercentage: 0,
        fldProcessLoss: 0,
        fldIsProcessLoss: false
    },
    selectedKnittingDetails: {},
    isPoDetailsDisabled: false,
    errorMessage: '',
    iperrorMessage: ''
};

export let knittingInwardDetailsReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;
    switch (type) {
        case FETCH_KNITTING_INWARD_DETAILS_REQUEST:
        case FETCH_KNITTING_INWARD_DETAILS_SO_AND_SN_REQUEST:
        case FETCH_PREVIOUS_KNITTING_INWARD_DETAILS_REQUEST:
        case FETCH_KNITTING_INWARD_DETAILS_BY_ID_REQUEST:
        case CREATE_KNITTING_INWARD_DETAILS_REQUEST:
        case FETCH_SINGLE_KNITTING_INWARD_DETAILS_REQUEST:
        case UPDATE_KNITTING_INWARD_DETAILS_REQUEST:
        case DELETE_KNITTING_INWARD_DETAILS_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_KNITTING_INWARD_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                knittingInwardDetails: updatePayload
            };
        case FETCH_KNITTING_INWARD_DETAILS_SO_AND_SN_SUCCESS:
            return {
                ...state,
                loading: false,
                SOAndSNGetList: updatePayload
            };
        case FETCH_PREVIOUS_KNITTING_INWARD_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                previousGetList: updatePayload?.KNII
            };
        case FETCH_KNITTING_INWARD_DETAILS_BY_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                knittingInwardDetailsById: updatePayload
            };

        case CREATE_KNITTING_INWARD_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                knittingInwardDetailsForm: {
                    fldItemRate: 0,
                    fldQuantity: 0,
                    fldReceivingRolls: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0,
                    fldProcessLoss: 0,
                    fldIsProcessLoss: false
                },
                isPoDetailsDisabled: false
            };
        case FETCH_SINGLE_KNITTING_INWARD_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedKnittingDetails: updatePayload,
                knittingInwardDetailsForm: { ...updatePayload }
            };
        case UPDATE_KNITTING_INWARD_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedKnittingDetails: {},
                knittingInwardDetailsForm: {
                    fldItemRate: 0,
                    fldQuantity: 0,
                    fldReceivingRolls: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0,
                    fldProcessLoss: 0,
                    fldIsProcessLoss: false
                },
                isPoDetailsDisabled: false
            };
        case DELETE_KNITTING_INWARD_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                knittingInwardDetailsForm: {
                    fldItemRate: 0,
                    fldQuantity: 0,
                    fldReceivingRolls: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0,
                    fldProcessLoss: 0,
                    fldIsProcessLoss: false
                },
                selectedKnittingDetails: {},
                isPoDetailsDisabled: false
            };

        case FETCH_KNITTING_INWARD_DETAILS_FAILURE:
        case FETCH_KNITTING_INWARD_DETAILS_SO_AND_SN_FAILURE:
        case FETCH_PREVIOUS_KNITTING_INWARD_DETAILS_FAILURE:
        case FETCH_SINGLE_KNITTING_INWARD_DETAILS_FAILURE:
        case CREATE_KNITTING_INWARD_DETAILS_FAILURE:
        case UPDATE_KNITTING_INWARD_DETAILS_FAILURE:
        case DELETE_KNITTING_INWARD_DETAILS_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_KNITTING_INWARD_DETAILS:
            return {
                ...state,
                loading: false,
                knittingInwardDetailsForm: {
                    ...state.knittingInwardDetailsForm,
                    [payload.key]: payload.value
                }
            };
        case KNITTING_INWARD_DETAILS_PO_DETAILS_DISABLED:
            return {
                ...state,
                isPoDetailsDisabled: payload
            };
        case KNITTING_INWARD_DETAILS_USERFORM_RESET:
            return {
                ...state,
                knittingInwardDetailsForm: {
                    fldItemRate: 0,
                    fldQuantity: 0,
                    fldReceivingRolls: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0,
                    fldProcessLoss: 0,
                    fldIsProcessLoss: false
                },
                selectedKnittingDetails: {},
                isPoDetailsDisabled: false
            };
        default:
            return state;
    }
};
